export default __webpack_public_path__ + "static/media/Scholar's Gloves of the Moon.af4dc44c.jpg";